<template>
    <div style="width: 100%" class="mt-5">
        <v-layout row wrap>
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-12 d-flex justify-space-between">
                        <div v-if="selected_affilation" @click="selected_affilation = null" class="d-flex mt-5 flex-row align-center hover">
                            <v-img max-height="32px" max-width="32px" :src="$root.getSrc('/default/drop_icons/left_arrow.svg')" contain></v-img>
                            <p class="ma-0 ml-5 fw-400 fs-18">Back to affiliations</p>
                        </div>
                        <div v-else></div>
                        <div v-if="!selected_affilation" class="d-flex">
                            <secondary-button class="ml-10" :activeButton="true">Refresh</secondary-button>
                            <primary-button @clickBtn="exportUsers" class="ml-5" :activeButton="true">Export CSV</primary-button>
                        </div>

                    </div>
                    <div class="col-md-12 mt-5">
                        <v-row wrap>
                            <div class="col-12">
                                <v-card class="my-shadow pa-3">
                                    <div class="row" style="border-bottom: 1px solid #E0E0E0;" v-if="isAdmin">
                                        <div v-if="!selected_affilation" class="col-md-5 pb-0 d-flex" :class="isAdmin ? 'justify-space-around' : 'justify-start'">
                                            <p class="ma-0 fs-16 fw-400" :class="isAdmin ? '' : 'mr-5'">Show:</p>
                                            <p class="ma-0 fs-18 hover" :class="[selectedTab == 'users' ? 'product-tab-active' : 'product-tab-inactive']" @click="selectedTab = 'users'">{{ 'All users'}}</p>
                                            <p class="ma-0 fs-18 hover" :class="[selectedTab != 'users' ? 'product-tab-active' : 'product-tab-inactive']" @click="selectedTab = 'affililations'">{{ 'Affiliations' }}</p>
                                        </div>
                                        <div v-else class="col-md-5 pb-0 ">
                                            <p class="ma-0 fw-400 fs-16">{{selected_affilation.charAt(0).toUpperCase() + selected_affilation.slice(1)}} affililation</p>
                                        </div>
                                        <div class="col-md-7 d-flex align-center justify-end">
                                            <div class="mr-4 d-flex flex-row">
                                                <p class="ma-0 fw-400 fs-18 d-flex align-center flex-row selectAmount">Show on site:
                                                    <v-select
                                                        style="display: inline-block;width: 20px!important;"
                                                        class="no-validation ml-2"
                                                        :items="[5,10,15,25]"
                                                        v-model="usersAmount"
                                                        dense
                                                        ref="users_amount"
                                                    ></v-select>
                                                    <v-img @click="$refs.users_amount.isMenuActive = true" class="hover" max-width="15px" max-height="15px" :src="$root.getSrc('/default/drop_icons/arrow_down.svg')" ></v-img>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row pl-4 pt-3 pb-3" style="border-bottom: 1px solid #E0E0E0;">
                                        <div class="col-md-12 d-flex align-center">
                                            <div class="row" :class="selectedTab != 'users' ? 'justify-space-between':null">
                                                <div class="col-md-5 d-flex align-center">
                                                    <v-text-field  v-model="term" class="no-validation" dense style="border-radius: 8px;" outlined append-icon="mdi-magnify" :class="[term.length == 0 ? 'product-name-filter' : '']" placeholder="What you are looking for?"></v-text-field>
                                                </div>
                                                <div v-if="selectedTab != 'users'" class="d-flex justify-end col-md-4">
                                                    <v-menu
                                                        ref="menu"
                                                        v-model="menu"
                                                        :close-on-content-click="false"
                                                        :return-value.sync="dates"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                outlined
                                                                dense
                                                                class="no-validation"
                                                                :value="dates.length > 1 ? dates[0] +' - '+ dates[1] : (dates.length > 0 ? dates[0] : '')"
                                                                label="Date"
                                                                prepend-icon="mdi-calendar"
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dates"
                                                            no-title
                                                            range
                                                            scrollable
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                text
                                                                color="primary"
                                                                @click="menu = false"
                                                            >
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn
                                                                text
                                                                color="primary"
                                                                @click="$refs.menu.save(dates)"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div class="row pl-4 pr-4" v-if="users && selectedTab == 'users'">
                                        <div class="drop-checkbox  pt-5 w-100">
                                            <v-data-table
                                                class="order-table"
                                                :loading="load"
                                                :items="users"
                                                :headers="headers"
                                                :hide-default-footer="true"
                                            >
                                                <template v-slot:item.id="{item}">
                                                    #{{item.id}}
                                                </template>
                                                <template v-slot:item.stores="{item}">
                                                    <div :key="'website_'+website.id" v-for="website in item.websites">
                                                        <span v-chunk="15">{{website.name}}</span>
                                                    </div>
                                                </template>

                                                <template v-slot:item.email="{item}">
                                                    <div :key="'email_'+item.id">
                                                        <span v-chunk="25" >{{item.email}}</span>
                                                    </div>
                                                </template>

                                                <template v-slot:item.last_login="{item}">
                                                    {{item.last_login ? getDate(item.last_login) : 'not logged in'}}
                                                </template>

                                                <template v-slot:item.actions="{item}">
                                                    <div class="d-flex justify-start align-center flex-row">
                                                        <router-link :to="'/users/'+item.id"><v-img  class="hover" max-width="24px" max-height="24px" contain :src="$root.getSrc('/default/drop_icons/edit_pencil.svg')"></v-img></router-link>
                                                        <v-img @click="deleteUser(item)" class="hover ml-5" max-width="24px" max-height="24px" contain :src="$root.getSrc('/default/drop_icons/trash.svg')"></v-img>
                                                    </div>
                                                </template>


                                            </v-data-table>
                                        </div>
                                    </div>
                                    <div v-else-if="!selected_affilation" class="row pl-4 pr-4">
                                        <v-data-table
                                            class="order-table w-100"
                                            :loading="load"
                                            :items="getAffiliationsArr"
                                            :headers="affiliationsHeaders"
                                            :hide-default-footer="true"
                                        >
                                            <template v-slot:item.name="{item}">
                                                {{item.name}}
                                            </template>
                                            <template v-slot:item.url="{item}">
                                                <span v-chunk="15">https://printdrop.com.au/register?utm_source={{item.name}}</span>
                                            </template>

                                            <template v-slot:item.users="{item}">
                                                <span>{{item.users}}</span>
                                            </template>

                                            <template v-slot:item.total="{item}">
                                                <span>{{(item.total).toFixed(2)}}&nbsp;AUD</span>
                                            </template>

                                            <template v-slot:item.turnover="{item}">
                                                <span>{{(item.total * 0.1).toFixed(2)}}&nbsp;AUD</span>
                                            </template>
                                            <template v-slot:item.actions="{item}">
                                                <v-btn :ripple="false" icon target="_blank" @click="selected_affilation = item.name">
                                                    <v-img max-height="22" contain :src="$root.getSrc('/default/drop_icons/eye.svg')"></v-img>
                                                </v-btn>
                                            </template>


                                        </v-data-table>
                                    </div>
                                    <div v-else-if="selected_affilation" class="row pl-4 pr-4">
                                        <v-data-table
                                            v-if="affilitations.length > 0"
                                            class="order-table w-100"
                                            :loading="load"
                                            :items="affilitations"
                                            :headers="selectedAffiliationsHeaders"
                                            :hide-default-footer="true"
                                        >
                                            <template v-slot:item.name="{item}">
                                                {{item.name}}
                                            </template>
                                            <template v-slot:item.store="{item}">
                                                <span>{{item.website}}</span>
                                            </template>

                                            <template v-slot:item.email="{item}">
                                                <span>{{item.email}}</span>
                                            </template>

                                            <template v-slot:item.revenue="{item}">
                                                <span>{{(item.revenue).toFixed(2)}}&nbsp;AUD</span>
                                            </template>

                                            <template v-slot:item.register_date_fixed="{item}">
                                                <span>{{getDate(item.register_date)}}</span>
                                            </template>
                                        </v-data-table>
                                    </div>


                                    <div v-if="selectedTab == 'users'" class="d-flex justify-end text-center mt-5">
                                        <v-pagination
                                            class="customed_pagination"
                                            v-model="page"
                                            :length="roundLength(total,10)"
                                            :total-visible="7"
                                        ></v-pagination>
                                    </div>
                                </v-card>
                            </div>
                        </v-row>
                    </div>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script>
import {deleteUsers, exportUsers, getAdminUsers} from "@/api/user";
import {getAffiliations} from "@/api/websites";

export default {

    data(){
        return{
            selectedWebsite: true,
            menu: false,
            usersAmount: 10,
            page:1,
            term: '',
            dates:[],
            selectedProductFilter: 'all',
            users: null,
            load: false,
            selectedTab: 'users',
            headers:[
                {
                    text: 'ID',
                    value: 'id',
                    sortable: false,
                    width: '70px',
                    align: 'left'
                },
                {
                    text: 'Name',
                    value: 'name',
                    sortable: false,
                    width: '150px',
                    align: 'left'
                },
                {
                    text: 'Stores',
                    value: 'stores',
                    sortable: false,
                    width: '120px',
                    align: 'left'
                },
                {
                    text: 'Email',
                    value: 'email',
                    sortable:false,
                    width: '150px',
                    align: 'left'
                },

                {
                    text: 'Last login',
                    value: 'last_login',
                    sortable: false,
                    width:'90px',
                    align: 'left'
                },
                {
                    text: '',
                    value: 'actions',
                    sortable: false,
                    width:'90px',
                    align: 'left'
                }
            ],
            affiliationsHeaders:[
                {
                    text: 'Name',
                    value: 'name',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: 'URL',
                    value: 'url',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: 'All users',
                    value: 'users',
                    sortable:false,
                    align: 'left'
                },

                {
                    text: 'Revenue',
                    value: 'total',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: 'Turnover',
                    value: 'turnover',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: '',
                    value: 'actions',
                    sortable: false,
                    align: 'left'
                },
            ],
            selectedAffiliationsHeaders:[
                {
                    text: 'Name',
                    value: 'name',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: 'Store',
                    value: 'store',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: 'Email',
                    value: 'email',
                    sortable:false,
                    align: 'left'
                },

                {
                    text: 'Revenue',
                    value: 'revenue',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: 'Register date',
                    value: 'register_date_fixed',
                    sortable: false,
                    align: 'left'
                },
            ],
            params: {},
            total: 0,
            affilitations: [],
            selected_affilation: null

        }
    },
    watch:{
        term: function(){
            this.getData();
        },
        selected_affilation: function(){
            this.affilitations = [];
            this.getData();
        },
        selectedTab: function(){
            this.term ? this.term = null : this.getData();
        },
        params:{
            handler: function () {
                this.getData();
            },
            deep: true
        },
        page:{
            handler: function () {
                this.getData();
            },
            deep: true
        },
        usersAmount: function(){
            this.getData();
        },
    },
    computed:{
        isAdmin(){
            return this.$store.getters.user.website_role.name == 'admin';
        },
        getAffiliationsArr(){
            let affArr = [];
            if(!this.selected_affilation){
                for ( const [key,value] of Object.entries( this.affilitations ) ) {
                    affArr.push(value);
                }
            }
            return affArr;
        }
    },
    mounted() {
        this.getData();
    },
    methods:{
        roundLength(total, itemsPerPage){
            return Math.ceil(total/itemsPerPage);
        },
        getData(){
            this.load = true;
            let obj = {
                term: this.term,
                page: this.page,
                per_page: this.usersAmount,
                itemsPerPage: this.usersAmount,
                dates: this.dates
            }
            if(this.selectedTab == 'users'){
                getAdminUsers(obj).then(res=>{
                    this.load = false;
                    this.users = res.data;
                    this.total = res.total;
                }).catch(e => {
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong...', type:'error'});
                    this.load = false;
                })
            } else {
                if(this.selected_affilation) obj.selected_affilation = this.selected_affilation;
                getAffiliations(obj).then(res=>{
                    this.load = false;
                    this.affilitations = res;
                }).catch(e => {
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong...', type:'error'});
                    this.load = false;
                })
            }

        },
        deleteUser(user){
            this.$confirm('Deleting user', 'Are you sure you want delete this user?',{accept: {text: 'Delete', color:'error'}, cancel: {text: 'Cancel', color: 'primary'}}).then(res => {
                this.deleteChosenUser(user);
            })
        },
        deleteChosenUser(user){
            this.load = true;
            deleteUsers(user.id).then(response => {
                this.$store.commit('app/ADD_MESSAGE', {text: this.$t('User deleted successfully'), type:'success'});
                this.getData();
            }).catch(e => {
                if(e.response.data.message){
                    this.$store.commit('app/ADD_MESSAGE', {text: e.response.data.message, type:'error'});
                }
                this.load = false;
            })
        },
        exportUsers(){
            exportUsers().then(res=>{
                this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Export file successfully created!'), type:'success'});
            })
        },
        getDate(date){
            var today = new Date(date);
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
            let minutes = today.getMinutes();
            if(minutes<10) minutes = '0'+minutes;

            let hours = today.getHours();
            var ampm = hours >= 12 ? ' PM' : ' AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'

            console.log(dd+'/'+mm+'/'+yyyy+' '+hours+':'+minutes + ampm)
            return dd+'/'+mm+'/'+yyyy+' '+hours+':'+minutes + ampm;
        },

    }
};
</script>

